/**
 * Accessibility Module
 * Handles accessibility enhancements
 */

export function initAccessibility(): void {
  // Reduce motion if user prefers
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (prefersReducedMotion.matches) {
    document.documentElement.style.setProperty('--transition-normal', '0ms');
    document.documentElement.style.setProperty('--transition-slow', '0ms');
  }

  // Handle focus visibility
  document.body.addEventListener('mousedown', () => {
    document.body.classList.add('using-mouse');
  });

  document.body.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Tab') {
      document.body.classList.remove('using-mouse');
    }
  });
}
